module.exports = ":host ::ng-deep mat-nav-list h3.mat-line {\n  white-space: pre-wrap !important; }\n"